import * as React from 'react';
import { SVGProps } from 'react';

export const DiffIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect
        x='0.5'
        y='0.51709'
        width='23'
        height='23'
        rx='11.5'
        stroke='black'
      />
      <g opacity='0.5' clipPath='url(#clip0_6325_18209)'>
        <rect x='5.5' y='8.51709' width='4' height='7' stroke='black' />
        <line
          x1='12'
          y1='5.01709'
          x2='12'
          y2='19.0171'
          stroke='black'
          strokeDasharray='4 2'
        />
        <rect x='14.5' y='8.51709' width='4' height='7' stroke='black' />
      </g>
      <defs>
        <clipPath id='clip0_6325_18209'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(4 4.01709)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AlertIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_2778_22836)'>
        <path
          d='M8 1C6.61553 1 5.26216 1.41054 4.11101 2.17971C2.95987 2.94888 2.06266 4.04213 1.53285 5.32122C1.00303 6.6003 0.86441 8.00776 1.13451 9.36563C1.4046 10.7235 2.07129 11.9708 3.05026 12.9497C4.02922 13.9287 5.2765 14.5954 6.63437 14.8655C7.99224 15.1356 9.3997 14.997 10.6788 14.4672C11.9579 13.9373 13.0511 13.0401 13.8203 11.889C14.5895 10.7378 15 9.38447 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1ZM8 14C6.81332 14 5.65328 13.6481 4.66658 12.9888C3.67989 12.3295 2.91085 11.3925 2.45673 10.2961C2.0026 9.19974 1.88378 7.99334 2.11529 6.82946C2.3468 5.66557 2.91825 4.59647 3.75736 3.75736C4.59648 2.91824 5.66558 2.3468 6.82946 2.11529C7.99335 1.88378 9.19975 2.0026 10.2961 2.45672C11.3925 2.91085 12.3295 3.67988 12.9888 4.66658C13.6481 5.65327 14 6.81331 14 8C14 9.5913 13.3679 11.1174 12.2426 12.2426C11.1174 13.3679 9.5913 14 8 14Z'
          fill='#FFCB00'
        />
        <path d='M8.5 4H7.5V9.5H8.5V4Z' fill='#FFCB00' />
        <path
          d='M8 11C7.85166 11 7.70666 11.044 7.58332 11.1264C7.45999 11.2088 7.36386 11.3259 7.30709 11.463C7.25032 11.6 7.23547 11.7508 7.26441 11.8963C7.29335 12.0418 7.36478 12.1754 7.46967 12.2803C7.57456 12.3852 7.7082 12.4566 7.85368 12.4856C7.99917 12.5145 8.14997 12.4997 8.28701 12.4429C8.42406 12.3861 8.54119 12.29 8.6236 12.1667C8.70601 12.0433 8.75 11.8983 8.75 11.75C8.75 11.5511 8.67098 11.3603 8.53033 11.2197C8.38968 11.079 8.19891 11 8 11Z'
          fill='#FFCB00'
        />
      </g>
      <defs>
        <clipPath id='clip0_2778_22836'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ResolveConflictLabel = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='64'
      height='73'
      viewBox='0 0 64 73'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.57143 51.4298V32.8571H21.1429L28.8571 40.2857H59.1429L59.8852 47.7096C62.505 43.0691 64 37.7093 64 32.0004C64 14.3271 49.6731 0 32 0C14.3269 0 0 14.3271 0 32.0004C0 39.3076 2.44919 46.0428 6.57143 51.4298Z'
        fill='#B1B1B1'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M26.8675 38.7679L20.6557 32.3448H7.63265V67.4739H32V71.2411H7.63265C6.66921 71.2411 5.74523 70.8442 5.06398 70.1377C4.38272 69.4313 4 68.4731 4 67.4739V32.3448C4 31.3457 4.38272 30.3875 5.06398 29.681C5.74523 28.9745 6.66921 28.5776 7.63265 28.5776H20.6557C21.1351 28.5772 21.6097 28.6752 22.0524 28.866C22.4951 29.0567 22.897 29.3364 23.2349 29.689L29.4286 36.112H56.3673C57.3308 36.112 58.2548 36.5089 58.936 37.2154C59.6173 37.9219 60 38.8801 60 39.8792V49.1429H56.3673V39.8792H27.921L26.8675 38.7679Z'
        fill='black'
      />
      <path
        d='M20.6557 32.3448L20.8611 32.1462L20.7769 32.0591H20.6557V32.3448ZM26.8675 38.7679L27.0749 38.5713L27.0729 38.5693L26.8675 38.7679ZM7.63265 32.3448V32.0591H7.34694V32.3448H7.63265ZM7.63265 67.4739H7.34694V67.7596H7.63265V67.4739ZM32 67.4739H32.2857V67.1882H32V67.4739ZM32 71.2411V71.5268H32.2857V71.2411H32ZM5.06398 70.1377L5.26965 69.9394L5.06398 70.1377ZM5.06398 29.681L5.26965 29.8793L5.06398 29.681ZM20.6557 28.5776V28.8634L20.6559 28.8634L20.6557 28.5776ZM22.0524 28.866L22.1655 28.6036V28.6036L22.0524 28.866ZM23.2349 29.689L23.0286 29.8867L23.0292 29.8873L23.2349 29.689ZM29.4286 36.112L29.2229 36.3104L29.3072 36.3977H29.4286V36.112ZM58.936 37.2154L59.1417 37.0171V37.0171L58.936 37.2154ZM60 49.1429V49.4286H60.2857V49.1429H60ZM56.3673 49.1429H56.0816V49.4286H56.3673V49.1429ZM56.3673 39.8792H56.6531V39.5935H56.3673V39.8792ZM27.921 39.8792L27.7137 40.0758L27.7982 40.1649H27.921V39.8792ZM20.4503 32.5435L26.6622 38.9665L27.0729 38.5693L20.8611 32.1462L20.4503 32.5435ZM7.63265 32.6305H20.6557V32.0591H7.63265V32.6305ZM7.91837 67.4739V32.3448H7.34694V67.4739H7.91837ZM32 67.1882H7.63265V67.7596H32V67.1882ZM32.2857 71.2411V67.4739H31.7143V71.2411H32.2857ZM7.63265 71.5268H32V70.9554H7.63265V71.5268ZM4.85831 70.3361C5.59228 71.0972 6.59002 71.5268 7.63265 71.5268V70.9554C6.74841 70.9554 5.89819 70.5912 5.26965 69.9394L4.85831 70.3361ZM3.71429 67.4739C3.71429 68.5455 4.12468 69.5753 4.85831 70.3361L5.26965 69.9394C4.64077 69.2872 4.28571 68.4006 4.28571 67.4739H3.71429ZM3.71429 32.3448V67.4739H4.28571V32.3448H3.71429ZM4.85831 29.4827C4.12468 30.2435 3.71429 31.2732 3.71429 32.3448H4.28571C4.28571 31.4182 4.64077 30.5315 5.26965 29.8793L4.85831 29.4827ZM7.63265 28.2919C6.59002 28.2919 5.59228 28.7215 4.85831 29.4827L5.26965 29.8793C5.89819 29.2275 6.74841 28.8634 7.63265 28.8634V28.2919ZM20.6557 28.2919H7.63265V28.8634H20.6557V28.2919ZM22.1655 28.6036C21.6872 28.3975 21.174 28.2915 20.6555 28.2919L20.6559 28.8634C21.0961 28.863 21.5323 28.953 21.9394 29.1284L22.1655 28.6036ZM23.4412 29.4912C23.0771 29.1115 22.6437 28.8096 22.1655 28.6036L21.9394 29.1284C22.3465 29.3038 22.7168 29.5613 23.0286 29.8867L23.4412 29.4912ZM29.6342 35.9137L23.4406 29.4906L23.0292 29.8873L29.2229 36.3104L29.6342 35.9137ZM56.3673 35.8263H29.4286V36.3977H56.3673V35.8263ZM59.1417 37.0171C58.4077 36.2559 57.41 35.8263 56.3673 35.8263V36.3977C57.2516 36.3977 58.1018 36.7619 58.7303 37.4137L59.1417 37.0171ZM60.2857 39.8792C60.2857 38.8076 59.8753 37.7779 59.1417 37.0171L58.7303 37.4137C59.3592 38.0659 59.7143 38.9526 59.7143 39.8792H60.2857ZM60.2857 49.1429V39.8792H59.7143V49.1429H60.2857ZM56.3673 49.4286H60V48.8571H56.3673V49.4286ZM56.0816 39.8792V49.1429H56.6531V39.8792H56.0816ZM27.921 40.1649H56.3673V39.5935H27.921V40.1649ZM26.6602 38.9645L27.7137 40.0758L28.1284 39.6827L27.0749 38.5713L26.6602 38.9645Z'
        fill='black'
      />
      <path
        d='M44.4224 71.8957L34.8867 62.358L37.5815 59.6632L44.4224 66.5023L58.8881 52.0347L61.5867 54.7333L44.4224 71.8957Z'
        fill='black'
        stroke='black'
        strokeWidth='0.571429'
      />
    </svg>
  );
};

export const CloudIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.3755 6.75C11.6467 6.75 10.1174 7.60388 9.18611 8.91623L8.72439 9.56688L8.10349 9.06587C7.82824 8.84377 7.47952 8.71131 7.09781 8.71131C6.21239 8.71131 5.49462 9.42908 5.49462 10.3145C5.49462 10.3642 5.49686 10.4132 5.50122 10.4615L5.55851 11.0958L4.94189 11.2551C3.68072 11.581 2.75 12.7273 2.75 14.089C2.75 15.7055 4.06038 17.0159 5.67681 17.0159C6.81271 17.0159 7.7988 16.3689 8.28438 15.42L8.7874 14.4369L9.51577 15.2669C10.4577 16.3402 11.8372 17.016 13.3755 17.016C14.4829 17.016 15.5064 16.6661 16.3443 16.0709L16.9163 15.6646L17.3598 16.2081C17.7628 16.7021 18.3739 17.0154 19.0587 17.0154C20.2689 17.0154 21.2499 16.0343 21.2499 14.8242C21.2499 13.6643 20.3483 12.7144 19.2083 12.638L18.5084 12.591L18.5085 11.883C18.5085 9.04811 16.2103 6.75 13.3755 6.75ZM8.39957 7.49694C9.61416 6.12013 11.3932 5.25 13.3755 5.25C16.8248 5.25 19.6592 7.8829 19.9785 11.2486C21.5723 11.6575 22.7499 13.1031 22.7499 14.8242C22.7499 16.8628 21.0973 18.5154 19.0587 18.5154C18.1485 18.5154 17.3151 18.1854 16.672 17.6399C15.7006 18.1972 14.5745 18.516 13.3755 18.516C11.733 18.516 10.2296 17.9184 9.0716 16.9302C8.26013 17.8987 7.04094 18.5159 5.67681 18.5159C3.23195 18.5159 1.25 16.5339 1.25 14.089C1.25 12.2324 2.39239 10.6442 4.01177 9.98629C4.17572 8.42673 5.49482 7.21131 7.09781 7.21131C7.56219 7.21131 8.00347 7.31369 8.39957 7.49694Z'
        fill='black'
      />
    </svg>
  );
};

export const CadFileIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='15'
      height='20'
      viewBox='0 0 15 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M7.56696 2.88315L1.54475 6.37642L7.56696 9.86969L13.5892 6.37642L7.56696 2.88315Z'
        stroke='#0F2EFF'
        strokeWidth='0.75'
        strokeLinejoin='round'
      />
      <path
        d='M14.6246 15.2767L14.6104 8.31472L8.57404 11.7835L8.5882 18.7455L14.6246 15.2767Z'
        stroke='#0F2EFF'
        strokeWidth='0.75'
        strokeLinejoin='round'
      />
      <path
        d='M0.375441 15.2767L0.389595 8.31472L6.42596 11.7835L6.4118 18.7455L0.375441 15.2767Z'
        stroke='#0F2EFF'
        strokeWidth='0.75'
        strokeLinejoin='round'
      />
    </svg>
  );
};
